export const prop = 'relatedSecondaryObjectImpacted';

export const config = (labels) => ({
	id: 'relatedSecondaryObjectImpactedColumn',
	label: labels.relatedSecondaryObjectImpacted,
	propName: prop,
	width: 'minmax(28rem, 3fr)',
	sortBy: prop
});
